// Library Imports
import React from 'react'
import { Card } from 'react-bootstrap'
// Asset Imports
import '../../assets/css/stylesheets/components/card/ContactCard.css'

function ContactCard({ header, textLine1, textLine2, icon}) {
    return (
        <Card className='contactcard slide-in-fwd-center'>
            <Card.Header className='contactcard-header'>
                <div className='contactcard-icon'>{icon}</div>
                <h2>{header}</h2>
            </Card.Header>
            <div className='contactcard-seperator'></div>
            <Card.Body>
                <Card.Text className='contactcard-text'>
                    {textLine1}
                    <br />
                    {textLine2}
                </Card.Text>
            </Card.Body>
        </Card>
    )
}

export default ContactCard